function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

import React from 'react';
import PropTypes from 'prop-types';
export var Icon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon(props) {
    var _this;

    _classCallCheck(this, Icon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icon).call(this, props));
    _this.state = {
      interaction: 'normal'
    };
    _this.mouseEnter = _this.mouseEnter.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.mouseLeave = _this.mouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.focusEvent = _this.focusEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.blurEvent = _this.blurEvent.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Icon, [{
    key: "mouseEnter",
    value: function mouseEnter() {
      this.setState(function (prevState) {
        if (prevState.interaction !== 'focused') {
          return {
            interaction: 'hovered'
          };
        }
      });
    }
  }, {
    key: "mouseLeave",
    value: function mouseLeave() {
      this.setState(function (prevState) {
        if (prevState.interaction !== 'focused') {
          return {
            interaction: 'normal'
          };
        }
      });
    }
  }, {
    key: "focusEvent",
    value: function focusEvent() {
      this.setState({
        interaction: 'focused'
      });
    }
  }, {
    key: "blurEvent",
    value: function blurEvent() {
      this.setState({
        interaction: 'normal'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var color = this.props.color;

      switch (this.state.interaction) {
        case 'normal':
          color = this.props.color;
          break;

        case 'hovered':
          color = this.props.hoverColor || this.props.color;
          break;

        case 'focused':
          color = this.props.focusColor || this.props.color;
          break;

        default:
          color = this.props.color;
      }

      return React.createElement("span", {
        className: "color-".concat(color),
        style: {
          position: 'relative',
          display: 'inline-flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: "".concat(this.props.size, "px"),
          height: "".concat(this.props.size, "px")
        },
        onMouseEnter: this.mouseEnter,
        onMouseLeave: this.mouseLeave,
        onFocus: this.focusEvent,
        onBlur: this.blurEvent,
        tabIndex: this.props.focusColor ? 0 : -1
      }, this.props.children);
    }
  }]);

  return Icon;
}(React.Component);
;
Icon.defaultProps = {
  size: 24,
  color: 'brand'
};
var validColorPropValues = PropTypes.oneOf(['p1', 'p2', 'p3', 'p4', 'p5', 'p6', 's1', 's1-washed', 's1-burned', 's2', 's2-washed', 's2-burned', 's3', 's3-washed', 's3-burned', 's4', 's4-washed', 's4-burned', 's5', 's5-washed', 's5-burned', 'danger', 'danger-washed', 'danger-burned', 'warning', 'warning-washed', 'warning-burned', 'success', 'success-washed', 'success-burned', 'brand', 'brand-washed', 'brand-burned']);
Icon.propTypes = {
  size: PropTypes.number,
  color: validColorPropValues,
  hoverColor: validColorPropValues,
  focusColor: validColorPropValues
};